<top-header-component />
<div class="main-container">
  @if (lockout | async) {
  <div class="overlay"></div>
  }
  <div class="left">
    <a [routerLink]="['/']" class="logo-container nav">
      <div class="logo-icon"></div>
    </a>
    @for (nav of navLinks; track nav) {
    <div [hidden]="noUser">
      @if (nav.hasAccess) {
      <div class="nav-link">
        @if (nav.counter && nav.hasAccess) {
        <div
          class="nav-counter"
          [pTooltip]="nav.counterTooltip || ''"
          [tooltipDisabled]="!nav.counterTooltip"
          tooltipPosition="bottom">
          <span>{{nav.counter}}</span>
        </div>
        } @if (nav.hasAccess && nav.url) {
        <a class="nav info" routerLinkActive="active-link" [routerLink]="nav.url">{{nav.displayText}}</a>
        } @if (nav.hasAccess && nav.externalUrl) {
        <a class="nav info" [href]="nav.externalUrl">{{nav.displayText}}</a>
        } @if (nav.hasAccess && nav.subMenu && !nav.externalUrl && !nav.url) {
        <a class="nav info" routerLinkActive="active-link">{{nav.displayText}}</a>
        } @if (nav.hasAccess && nav.subMenu) {
        <div class="sub-menu-container">
          @for (subNav of nav.subMenu; track subNav) {
          <div>
            @if (subNav.hasAccess&& subNav.url) {
            <a routerLinkActive="active-link" [routerLink]="subNav.url" class="sub-menu-link">
              <a class="sub-menu">{{subNav.displayText}}</a>
            </a>
            } @if (subNav.hasAccess && subNav.externalUrl) {
            <a routerLinkActive="active-link" [href]="subNav.externalUrl" class="sub-menu-link">
              <a class="sub-menu">{{subNav.displayText}}</a>
            </a>
            }
          </div>
          }
        </div>
        }
      </div>
      }
    </div>
    }
  </div>
  <div class="right">
    @if (!noUser && showClinicList) {
    <div class="selected-clinic">
      <div
        class="selected-clinic-nav user-infomations"
        [ngClass]="{'selected-clinic-nav-active': displaySearch}"
        (click)="showSearch()">
        <span class="selected-label">Selected Clinic:</span>
        <div class="selcted-clinic-name">
          <i class="fa-solid fa-location-dot"></i>
          {{selectedClinic?.CenterDisplayName}}
        </div>
      </div>
      <div class="search-clinic" [ngClass]="{'display-search': displaySearch}">
        <div class="search-input-container">
          <span>Quick Jump:</span>
          <div class="search-input">
            <input
              #searchClinicInputRef
              type="text"
              pInputText
              placeholder="Enter Center ID"
              [(ngModel)]="searchClinicInput"
              (ngModelChange)="searchClinicInputChange()"
              (keydown.enter)="goToClinic()" />
            <button
              pButton
              type="button"
              label="Go"
              [disabled]="!centerCodeList?.length"
              (click)="goToClinic()"></button>
          </div>
        </div>
        <div class="search-clinic-container">
          @if (searchClinicResult?.length) {
          <span>Available Clinics:</span>
          } @for (clinic of searchClinicResult; track clinic) {
          <div class="clinic-link">
            <a (click)="selectClinicLink(clinic)">{{clinic?.CenterDisplayName}}</a>
          </div>
          } @if (filterClinicList?.length > 25) {
          <div class="clinics-number">... and {{filterClinicList?.length - searchClinicResult?.length}} more.</div>
          } @if (!searchClinicResult?.length) {
          <span class="clinics-number">No items</span>
          }
        </div>
      </div>
    </div>
    }
    <div class="user-infomations">
      @if (!noUser) {
      <div class="log-out-container">
        <span class="user">{{ userLogin }}</span>
        <a class="sign-out" (click)="logout()">Exit SW</a>
      </div>
      }
      <div appQuadrupleClick (quadrupleClick)="openSecretMenu()" class="fresesius-logo"></div>
    </div>
  </div>
</div>
